import {Fragment, useMemo} from 'react';
import {Message, MessageAttachment} from '@/api/dto/message';
import {useAuthStore} from '@/store/auth_store';
import {Wrapper, LastSeen, LastSeenLine} from '@common/messages/Conversation.styles';
import MessageItem from '@common/messages/MessageItem';

type Props = {
  messages: Message[];
  lastSeenMessage?: Message;
  onAttachmentDelete(message: Message, attachment: MessageAttachment): void;
}

export default function Conversation(props: Props) {
  const { currentUser } = useAuthStore();

  const messagesSorted = useMemo(
    () => props.messages.sort((a, b) =>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()),
    [props.messages],
  );

  const isLastSeenVisible = (message: Message) => {
    return message.id === props.lastSeenMessage?.id &&
      messagesSorted[0]?.id !== props.lastSeenMessage.id &&
      messagesSorted[0]?.user.id !== currentUser?.id;
  };

  return (
    <Wrapper>
      {messagesSorted.map((message) => (
        <Fragment key={message.id}>
          {isLastSeenVisible(message) && (
            <LastSeen data-last-seen-message>
              Last seen
              <LastSeenLine />
            </LastSeen>
          )}
          <MessageItem
            message={message}
            own={message.user.id === currentUser?.id}
            onAttachmentDelete={props.onAttachmentDelete}
          />
        </Fragment>
      ))}
    </Wrapper>
  );
}
